/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */

import { useQuery } from "@tanstack/react-query";
import { getSubscriptions } from "./queryFunctions";

export const useGetSubscriptions = (userId: string) => {
  return useQuery({
    queryKey: ["subscriptions", userId],
    queryFn: () => getSubscriptions(userId),
  });
};
